export default "__VITE_ASSET__CplaCTeY__"